/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a point of sale system that we support.
 * @export
 * @interface Pos
 */
export interface Pos {
    /**
     * 
     * @type {string}
     * @memberof Pos
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Pos
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Pos
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof Pos
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Pos
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Pos
     */
    itsaCheckmateLabel?: string;
}

/**
 * Check if a given object implements the Pos interface.
 */
export function instanceOfPos(value: object): value is Pos {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PosFromJSON(json: any): Pos {
    return PosFromJSONTyped(json, false);
}

export function PosFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pos {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'itsaCheckmateLabel': json['itsaCheckmateLabel'] == null ? undefined : json['itsaCheckmateLabel'],
    };
}

export function PosToJSON(json: any): Pos {
    return PosToJSONTyped(json, false);
}

export function PosToJSONTyped(value?: Pos | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'itsaCheckmateLabel': value['itsaCheckmateLabel'],
    };
}

